// extracted by mini-css-extract-plugin
export default {"cls1":"YFbNSscBkxVJVAVmi6Ek","cls2":"qkycFxlpSHtdoKSUZviO YFbNSscBkxVJVAVmi6Ek","isPhone":"__KnQYW7lL_kp4I5ckkb"};